<template>
  <div class="form-check" :class="[ type === 'checkbox' ? 'form-check--checkbox' : 'form-check--radio']">
    <slot></slot>
    <label class="form-check__label" :for="id">
      {{ label }}
      <slot name="label"></slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: [String, Number],
    label: String,
    type: String,
    option: Object
  }
}
</script>

<style lang="scss" scoped>
.form-check {
  display: block;
  font-size: $font-size-lg;
  min-height: $font-size-lg * $line-height-base;
  padding-left: $custom-control-gutter + $custom-control-indicator-size;
  position: relative;

  > input {
    position: absolute;
    left: 0;
    z-index: -1;
    width: $custom-control-indicator-size;
    height: ($font-size-lg * $line-height-base + $custom-control-indicator-size) / 2;
    opacity: 0;

    &:checked ~ .form-check__label {
      color: $theme-black;
    }

    &:checked ~ .form-check__label::before {
      color: $custom-control-indicator-checked-color;
      border-color: $theme-red-100;
    }

    &:focus:not(:checked) ~ .form-check__label::before {
      border-color: $theme-red-100;
    }

    &:not(:disabled):active ~ .form-check__label::before {
      color: $custom-control-indicator-active-color;
      background-color: $custom-control-indicator-active-bg;
    }

    &[disabled],
    &:disabled {
      ~ .form-check__label {
        color: $custom-control-label-disabled-color;

        &::before {
          background-color: $custom-control-indicator-disabled-bg;
        }
      }
    }
  }

  &__label {
    color: $theme-gray-700;
    cursor: pointer;
    line-height: $line-height-base;
    font-weight: normal;
    margin-bottom: 0;
    position: relative;
    vertical-align: top;

    :hover > & {
      color: $theme-black;

      &::before {
        border-color: $theme-red-100;
      }
    }

    // Background-color and (when enabled) gradient
    &::before {
      position: absolute;
      top: ($font-size-lg * $line-height-base - $custom-control-indicator-size) / 2;
      left: -($custom-control-gutter + $custom-control-indicator-size);
      display: block;
      width: $custom-control-indicator-size;
      height: $custom-control-indicator-size;
      pointer-events: none;
      content: '';
      background-color: $custom-control-indicator-bg;
      border: $theme-gray-600 solid 2px;
    }

    // Foreground (icon)
    &::after {
      position: absolute;
      top: ($font-size-lg * $line-height-base - $custom-control-indicator-size) / 2;
      left: -($custom-control-gutter + $custom-control-indicator-size);
      display: block;
      width: $custom-control-indicator-size;
      height: $custom-control-indicator-size;
      content: '';
      background: no-repeat 50% / #{$custom-control-indicator-bg-size};
    }
  }
}

.form-check--checkbox {
  input:checked ~ .form-check__label {
    &::before {
      background-color: $theme-red-100;
    }

    &::after {
      background-image: escape-svg($custom-checkbox-indicator-icon-checked);
    }
  }

  input:indeterminate ~ .form-check__label {
    &::before {
      border-color: $custom-checkbox-indicator-indeterminate-border-color;
    }
    &::after {
      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);
    }
  }

  input:disabled {
    &:checked ~ .form-check__label::before {
      background-color: $custom-control-indicator-checked-disabled-bg;
    }
    &:indeterminate ~ .form-check__label::before {
      background-color: $custom-control-indicator-checked-disabled-bg;
    }
  }
}

.form-check--radio {
  .form-check__label::before {
    border-radius: $custom-radio-indicator-border-radius;
  }

  input:checked ~ .form-check__label {
    &::before {
      background-color: $theme-red-100;
    }

    &::after {
      background-image: escape-svg($custom-radio-indicator-icon-checked);
    }
  }

  input:disabled {
    &:checked ~ .form-check__label::before {
      background-color: $custom-control-indicator-checked-disabled-bg;
    }
  }
}
</style>
